<div class="menu">
  @for (item of menuStructure(); track item.text) {
    @if (item.component === 'menu_item') {
      <a
        appButton
        shape="round"
        name="{{ item.text | lowercase }}"
        location="website-header"
        color="simple-gray"
        weight="bold"
        [routerLink]="[item.link | storyblokLink]"
        class="top-level-button"
      >
        <span>{{ item.text }}</span>
      </a>
    } @else {
      <div class="nav-dropdown" (mouseenter)="hoverOpen(item.text)" (mouseleave)="hoverClose(item.text)">
        <button
          appButton
          shape="round"
          name="{{ item.text | lowercase }}"
          location="website-header"
          color="simple-gray"
          weight="bold"
          class="top-level-button"
          [class.constant]="openDropdown() === item.text"
          aria-haspopup="true"
          [attr.aria-expanded]="openDropdown() === item.text"
          (click)="toggle(item.text)"
        >
          <span>{{ item.text }}</span>
          <svg
            class="custom-svg header-chrome-icon"
            viewBox="0 0 16 16"
            width="16"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M11 6.5L8 9.5L5 6.5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <!-- Always rendered (SSR-crawlable links); closed = invisible + inert.
             theme-light: panel stays white even under dark header chrome. -->
        <div
          class="dropdown-panel theme-light"
          [class.open]="openDropdown() === item.text"
          [attr.aria-hidden]="openDropdown() === item.text ? null : 'true'"
          [attr.inert]="openDropdown() === item.text ? null : ''"
        >
          <div class="dropdown-menu">
            @for (subItem of item.buttons; track subItem.text) {
              @if (subItem.link.linktype === 'story') {
                <a
                  name="website-header: {{ subItem.text | lowercase }}"
                  [routerLink]="[subItem.link | storyblokLink]"
                  (click)="closeAll()"
                >
                  <div class="icon-container">
                    <app-svg [src]="subItem.icon.filename | storyblokCdn"></app-svg>
                  </div>
                  <span>{{ subItem.text }}</span>
                </a>
              } @else {
                <a
                  name="website-header: {{ subItem.text | lowercase }}"
                  [href]="subItem.link.url"
                  target="_blank"
                  (click)="closeAll()"
                >
                  <div class="icon-container">
                    <app-svg [src]="subItem.icon.filename | storyblokCdn"></app-svg>
                  </div>
                  <span>{{ subItem.text }}</span>
                </a>
              }
            }
          </div>
        </div>
      </div>
    }
  }
</div>
